export default __webpack_public_path__ + "static/media/digid-logo.eaf08c3b.svg";